import ContactSection from '../sections/ContactSection'
import { SubHeroInternal } from '@web/components/SubHeroInternal'
import { InternalHero } from '@web/components/InternalHero'
import LinkedInComponent from '@web/components/LinkedInComponent'

const ContactPage = () => {
  return (
    <>
      <InternalHero backgroundImage="/website/hero_background_internal.jpg" />
      <SubHeroInternal variant="gradient">
        <h1 className="text-h1 font-light text-text-inverted text-balance ">
          Ready to understand your risks and build resilience?
        </h1>
      </SubHeroInternal>
      <ContactSection isInternalPage={true} />
      <LinkedInComponent />
    </>
  )
}

export default ContactPage
